import axios from 'axios'

export const state = {
  categories : {},
}

export const getters = {
  listCategories (state) {
    return state.categories
  },
}

export const mutations = {
  SET_CATEGORIES (state, categories) {
    state.categories = categories
  },
}

export const actions = {
  async getCategories({ commit }, params = {}) {
    const { data } = await axios.get('/categories', { params })
    return commit('SET_CATEGORIES', data)
  },
  getListCategories({ commit }, params = {}) {
    return axios.get('/categories', { params })
  },
}
